export default __webpack_public_path__ + "static/media/stockanalytics.6486cdc3.jpg";